import React from 'react';
import { Link } from 'react-router-dom';
import appLogo from '../assets/branding/logo.png';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-shell">
        <div className="footer-brand">
          <img src={appLogo} alt="" />
          <div>
            <strong>KinetoCut</strong>
            <p>Shape the moment. Keep the original.</p>
          </div>
        </div>
        <nav className="footer-links" aria-label="Footer navigation">
          <Link to="/">Home</Link>
          <Link to="/support">Support</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </div>
      <div className="footer-meta">
        <p>© {new Date().getFullYear()} KinetoCut. All rights reserved.</p>
        <p><span className="status-dot" /> Built for focused, non-destructive editing</p>
      </div>
    </footer>
  );
}
